<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Programas</h4>
            </vs-col>
            <vs-col sm="12" lg="4">
                <vs-button
                    class="ml-auto"
                    success
                    @click="activeCrear =! activeCrear"
                >
                    Crear registro
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="nivel" class="labelInput">
                        Nivel Académico <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingNivel" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="!niveles.length">
                        <template #message-danger v-if="errorFields.includes('nivel')">
                            Requerido
                        </template>
                        <template v-if="niveles.length" autocomplete="off">
                            <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Nombre
                    </label>
                     <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre" />
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getAcademicoProgramas()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-programas :users="users" :instituciones="instituciones" :token="csrf_token" @refreshTable="getAcademicoProgramas"></tabla-programas>
        <crear v-model="activeCrear" :instituciones="instituciones" :token="csrf_token" @refreshTable="getRefresh"></crear>
    </div>
</template>

<script>
import academico from '../../../../api/requests/academico'
import TablaProgramas from './tabla-programa.vue'
import crear from './modales/crear.vue'
export default {
    props: [ 'csrf_token' ],
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            nivel: '',
            niveles: [],
            nivelId: (new Date()).getTime(),
            nombre: '',
            loadingNivel: false,
            errorFields: [],
            users: [],
            activeCrear: false
        }
    },
    created(){
        this.getInstituciones()
    },
    components:{
        TablaProgramas,
        crear
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.nivel = ''
                this.loadingNivel = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingNivel = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (this.institucion == '') {
                this.errorFields.push('institucion')
            }
            if (this.nivel == '') {
                this.errorFields.push('nivel')
            }
            if (!this.errorFields.length){
                const params = {
                    "institucion_id": this.institucion,
                    "nivel_academico_id": this.nivel,
                    "nombre": this.nombre,
                    "page": 1
                }
                return params
            } else {
                return null
            }
        },
        async getAcademicoProgramas(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.getAcademicoProgramas(params)
                    this.users = response.data
                    loading.close()
                }catch{
                    loading.close()
                }
            }
        },
        async getRefresh(institucion, nivel){
            const loading = this.$vs.loading()
            this.institucion = institucion
            this.nivel = nivel
            try{
                const params = {
                    "institucion_id": this.institucion,
                    "nivel_academico_id": this.nivel,
                    "nombre": this.nombre,
                    "page": 1
                }
                const { data: response } = await academico.getAcademicoProgramas(params)
                this.users = response.data
                this.nivel = nivel
                loading.close()
            }catch{
                loading.close()
            }
        }
    },
    watch:{
        institucion(){
            this.getNivelAcademico()
        }
    }
}
</script>